var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RightMenu'),_c('i',{on:{"click":function($event){return _vm.setShowRight(true)}}},[_c('a',{staticClass:"fas fa-bars",staticStyle:{"color":"#fff"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }